import { render, staticRenderFns } from "./work.vue?vue&type=template&id=7b2773ec&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"
import style0 from "./work.vue?vue&type=style&index=0&id=7b2773ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2773ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2773ec')) {
      api.createRecord('7b2773ec', component.options)
    } else {
      api.reload('7b2773ec', component.options)
    }
    module.hot.accept("./work.vue?vue&type=template&id=7b2773ec&scoped=true", function () {
      api.rerender('7b2773ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/work.vue"
export default component.exports